import { render, staticRenderFns } from "./UpdatedPassword.vue?vue&type=template&id=0e5c35de&scoped=true"
import script from "./UpdatedPassword.vue?vue&type=script&lang=js"
export * from "./UpdatedPassword.vue?vue&type=script&lang=js"
import style0 from "./UpdatedPassword.vue?vue&type=style&index=0&id=0e5c35de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c35de",
  null
  
)

export default component.exports